export default __webpack_public_path__ + "static/media/sniper-rifles.ff473076.svg";